module.exports = __webpack_public_path__ + "static/media/moduleSet_i4o0.97558f9b.jpg";